import React from 'react';
export function CalculatorForm() {
  return <div className="w-full" data-id="element-64">
      <iframe src="https://link.getdealflow.ai/widget/form/sASqpN2PVwFnTDdu5tzI" style={{
      width: '100%',
      height: '500px',
      border: 'none',
      borderRadius: '3px'
    }} id="inline-sASqpN2PVwFnTDdu5tzI" data-layout="{'id':'INLINE'}" data-trigger-type="alwaysShow" data-trigger-value="" data-activation-type="alwaysActivated" data-activation-value="" data-deactivation-type="neverDeactivate" data-deactivation-value="" data-form-name="Calculator LM Opt In Form" data-height="500" data-layout-iframe-id="inline-sASqpN2PVwFnTDdu5tzI" data-form-id="sASqpN2PVwFnTDdu5tzI" title="Calculator LM Opt In Form" data-id="element-65"></iframe>
    </div>;
}